import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PageRoute from './Route';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PageRoute />
  </React.StrictMode>
);

